{
  "page": {
    "intro": "ส่งไปที่ไหน ค่าส่งเท่าไร บริษัทขนส่ง และภาษีนำเข้า — ลูกค้าเห็นตามที่ตั้งไว้ที่นี่ทุกอย่าง",
    "read_only": "ดูการตั้งค่านี้ได้อย่างเดียว เฉพาะเจ้าของร้านที่แก้ได้"
  },
  "tabs": {
    "label": "ตั้งค่าการส่งของ",
    "zones": "ส่งไปที่ไหน",
    "carriers": "บริษัทขนส่ง",
    "duties": "ภาษีนำเข้า",
    "packaging": "การแพ็ก",
    "calculator": "ลองคิดค่าส่ง"
  },
  "lang": {
    "en": "อังกฤษ",
    "ja": "ญี่ปุ่น",
    "th": "ไทย",
    "zh-Hant": "จีน (ตัวเต็ม)",
    "zh-Hans": "จีน (ตัวย่อ)",
    "en_hint": "ภาษาที่เว้นว่างจะใช้ข้อความภาษาอังกฤษนี้"
  },
  "zones": {
    "intro": "โซนคือกลุ่มพื้นที่ที่ใช้วิธีส่งชุดเดียวกัน ประเทศ (หรือจังหวัดของญี่ปุ่น) หนึ่งอยู่ได้แค่โซนเดียว",
    "add": "เพิ่มโซน",
    "start_from": "เริ่มจาก",
    "start_empty": "โซนว่าง (เลือกประเทศเอง)",
    "rest_of_world": "ประเทศอื่นทั้งหมด (ประเทศที่ยังไม่อยู่ในโซนไหน)",
    "countries_count_other": "{{count}} ประเทศ",
    "more_other": "+อีก {{count}}",
    "empty_title": "ยังไม่มีโซน",
    "empty_body": "เพิ่มโซนญี่ปุ่นก่อน แล้วเพิ่มโซนสำหรับแต่ละกลุ่มประเทศที่ส่งไป",
    "load_failed": "โหลดโซนการส่งไม่ได้",
    "on": "ลูกค้าเลือกได้",
    "off": "ปิดอยู่",
    "edit": "แก้พื้นที่",
    "view": "ดูพื้นที่",
    "rates_of": "วิธีส่งไป {{zone}}",
    "no_rates": "ยังไม่มีวิธีส่ง — ลูกค้าในโซนนี้สั่งไม่ได้จนกว่าจะเพิ่ม",
    "upcoming": "ค่าส่งที่จะเปลี่ยนภายหลัง",
    "past_other": "ค่าส่งเก่า {{count}} รายการ (เก็บไว้ให้ออเดอร์ที่สั่งแล้ว)",
    "carriers_all": "บริษัทขนส่ง: ทุกบริษัท",
    "carriers_some": "บริษัทขนส่ง: {{names}}"
  },
  "zone": {
    "new": "โซนใหม่",
    "new_from": "โซนใหม่: {{name}}",
    "description": "ประเทศในโซนนี้ และสำหรับญี่ปุ่น ทั้งประเทศหรือบางจังหวัด",
    "name": "ชื่อโซน",
    "name_required": "ใส่ชื่อภาษาอังกฤษ (ใช้แทนภาษาที่เว้นว่าง)",
    "countries_other": "ประเทศในโซนนี้ ({{count}})",
    "chosen": "ประเทศที่เลือก",
    "no_countries": "ยังไม่ได้เลือกประเทศ",
    "remove_country": "เอา {{name}} ออก",
    "search_country": "ค้นหาประเทศ",
    "countries_required": "เลือกอย่างน้อย 1 ประเทศ",
    "japan_part": "ส่วนไหนของญี่ปุ่น",
    "japan_all": "ทั่วญี่ปุ่น",
    "japan_some": "เฉพาะบางจังหวัด (คิดราคาแยก เช่น โอกินาวา)",
    "prefectures": "จังหวัด",
    "regions_required": "ติ๊กอย่างน้อย 1 จังหวัด หรือเลือก \"ทั่วญี่ปุ่น\"",
    "left_out": "อยู่ในโซนอื่นแล้ว จึงไม่ได้ใส่: {{places}}",
    "active": "ลูกค้าเลือกโซนนี้ได้",
    "active_hint": "ปิดเพื่อหยุดให้เลือกโดยไม่ต้องลบอะไร",
    "note": "โน้ตของร้าน (ลูกค้าไม่เห็น)",
    "save": "บันทึกโซน",
    "created": "เพิ่มโซนแล้ว",
    "saved": "บันทึกโซนแล้ว",
    "delete": "ลบโซน",
    "delete_title": "ลบโซน {{name}}?",
    "delete_body": "ลูกค้าในพื้นที่เหล่านี้จะสั่งไม่ได้ ออเดอร์ที่สั่งแล้วยังใช้ค่าส่งเดิม",
    "cannot_delete_title": "{{name}} ยังมีวิธีส่งอยู่",
    "cannot_delete_body_other": "ยังมีวิธีส่ง {{count}} แบบ จึงลบไม่ได้ ให้ปิดโซนแทน: ลูกค้าจะไม่เห็นอีก ออเดอร์ที่สั่งแล้วยังใช้ค่าส่งเดิม",
    "switch_off": "ปิดโซนนี้",
    "switched_off": "ปิดโซนแล้ว",
    "deleted": "ลบโซนแล้ว",
    "carriers": "บริษัทขนส่งที่ใช้ในโซนนี้",
    "carriers_all": "ทุกบริษัท",
    "carriers_some": "เฉพาะบริษัทที่ติ๊ก",
    "carriers_hint": "วิธีส่งของบริษัทที่ไม่ได้ติ๊กยังเก็บไว้ แต่ลูกค้าในโซนนี้จะไม่เห็น",
    "carriers_required": "ติ๊กบริษัทขนส่งอย่างน้อย 1 บริษัท หรือเลือก \"ทุกบริษัท\""
  },
  "rate": {
    "add": "เพิ่มวิธีส่ง",
    "new_in": "วิธีส่งใหม่ — {{zone}}",
    "description": "ค่าส่งของร้านเอง รวมภาษีแล้ว ลูกค้าเห็นแบบถูกที่สุดก่อน",
    "edit": "แก้",
    "view": "ดู",
    "save": "บันทึก",
    "created": "เพิ่มวิธีส่งแล้ว",
    "saved": "บันทึกวิธีส่งแล้ว",
    "off": "(ปิดอยู่)",
    "name": "ชื่อที่ลูกค้าเห็น",
    "carrier": "บริษัทขนส่ง",
    "how_priced": "คิดค่าส่งอย่างไร",
    "type": {
      "flat": "ราคาเดียว",
      "weight": "ตามน้ำหนัก",
      "price": "ตามยอดซื้อ",
      "free_over": "ส่งฟรีเมื่อซื้อครบ",
      "pickup": "รับที่ร้าน"
    },
    "type_hint": {
      "flat": "ทุกกล่องราคาเท่ากัน (เช่น クリックポスト)",
      "weight": "ราคาตามขั้นน้ำหนัก (เช่น ゆうパック)",
      "price": "ราคาตามขั้นยอดซื้อ",
      "free_over": "มีค่าส่ง แต่ฟรีเมื่อยอดซื้อถึงจำนวนที่ตั้ง"
    },
    "price": "ค่าส่ง",
    "free_from": "ส่งฟรีเมื่อยอดซื้อตั้งแต่",
    "free_from_hint": "ยอดซื้อหลังหักส่วนลด",
    "tiers_weight": "ค่าส่งตามน้ำหนัก",
    "tiers_weight_hint": "เรียงจากเบาไปหนัก กล่องใช้ขั้นแรกที่ใส่ได้ หนักกว่าขั้นสุดท้าย = ไม่แสดงวิธีนี้",
    "tiers_price": "ค่าส่งตามยอดซื้อ",
    "tiers_price_hint": "เรียงจากยอดน้อยไปมาก เว้นช่อง \"ถึง\" ของแถวสุดท้ายว่าง = \"ขึ้นไป\"",
    "tier_up_to_g": "แถว {{row}}: ถึงกี่กรัม",
    "tier_up_to_yen": "แถว {{row}}: ยอดซื้อถึง",
    "tier_last_hint": "ว่าง = ขึ้นไป",
    "tier_price": "แถว {{row}}: ค่าส่ง",
    "tier_remove": "ลบแถว {{row}}",
    "tier_add": "เพิ่มแถว",
    "max_weight": "น้ำหนักกล่องสูงสุด",
    "max_weight_hint": "ว่าง = ไม่มีขีดจำกัดของตัวเอง",
    "eta_min": "ถึงภายใน (เร็วสุด)",
    "eta_max": "ถึงภายใน (ช้าสุด)",
    "days": "วัน",
    "eta_days": "{{min}}–{{max}} วัน",
    "protection": "การติดตามและประกัน",
    "tracked": "มีเลขพัสดุ",
    "insured": "มีประกัน (บริษัทจ่ายเมื่อหาย/เสียหาย)",
    "insured_rule": "ออเดอร์ตั้งแต่ {{amount}} จะเห็นเฉพาะวิธีที่มีประกัน",
    "coverage": "ประกันสูงสุด",
    "coverage_hint": "ว่าง = เต็มมูลค่า",
    "can_add_insurance": "ซื้อประกันเพิ่มได้",
    "signature": "ต้องเซ็นรับ",
    "more": "ตัวเลือกเพิ่มเติม",
    "service_level": "ประเภทบริการ",
    "service_level_none": "ไม่ระบุ",
    "service_tier": {
      "economy_tracked": "ประหยัด มีเลขพัสดุ",
      "standard_insured": "มาตรฐาน มีประกัน",
      "express_courier": "ด่วน (คูเรียร์)"
    },
    "duties_default": "ภาษีนำเข้า (ค่าเริ่มต้นของวิธีนี้)",
    "duties_default_hint": "กล่องไปสหรัฐทางไปรษณีย์ $100–2,500 ร้านจ่ายล่วงหน้าเสมอ (ระบบตั้งให้เอง)",
    "min_subtotal": "ใช้ได้เมื่อยอดซื้อตั้งแต่",
    "max_subtotal": "ใช้ได้เมื่อยอดซื้อไม่เกิน",
    "max_declared": "มูลค่าของสูงสุดที่ส่งได้",
    "starts_on": "ค่าส่งนี้เริ่มวันที่",
    "starts_on_hint": "ว่าง = วันนี้ ถ้าเป็นวันหลัง ค่าส่งเดิมใช้ต่อจนถึงวันนั้น",
    "active": "ลูกค้าเลือกได้",
    "active_hint": "ปิดเพื่อหยุดให้เลือกโดยไม่ต้องลบ",
    "notes": "โน้ตของร้าน",
    "notes_hint": "เช่น ราคามาจากไหน ลูกค้าไม่เห็น",
    "starts": "เริ่ม {{date}}",
    "badge": {
      "insured": "มีประกัน",
      "signature": "เซ็นรับ",
      "untracked": "ไม่มีเลขพัสดุ",
      "unverified": "ยังไม่ได้ตรวจราคา",
      "max_thickness": "หนาไม่เกิน {{mm}} มม.",
      "carrier_off": "ปิดบริษัทนี้ในโซนนี้ — ลูกค้าไม่เห็น"
    },
    "summary": {
      "up_to": "ถึง {{limit}} {{price}}",
      "above": "ขึ้นไป: {{price}}",
      "free_over": "{{price}} ฟรีเมื่อซื้อตั้งแต่ {{from}}"
    },
    "delete": "ลบ",
    "delete_named": "ลบ {{name}}",
    "delete_title": "ลบ {{name}}?",
    "delete_consequence": "ลูกค้าจะเลือกไม่ได้อีก ออเดอร์ที่สั่งแล้วยังใช้ค่าส่งเดิม",
    "deleted": "ลบวิธีส่งแล้ว",
    "problem": {
      "fix_marked": "กรุณาแก้ช่องที่มีเครื่องหมาย",
      "name_en": "ใส่ชื่อภาษาอังกฤษ (ใช้แทนภาษาที่เว้นว่าง)",
      "carrier": "เลือกบริษัทขนส่ง",
      "price": "ใส่ค่าส่งเป็นเยนจำนวนเต็ม",
      "tiers_empty": "เพิ่มอย่างน้อย 1 แถวที่มีค่าส่ง",
      "tiers_weight": "ทุกแถวต้องมีน้ำหนัก (กรัม) และค่าส่ง (เยนจำนวนเต็ม)",
      "tiers_price": "ทุกแถวต้องมีค่าส่ง เฉพาะแถวสุดท้ายที่เว้น \"ถึง\" ว่างได้",
      "free_over": "ใส่ยอดซื้อที่ส่งฟรี",
      "numbers": "น้ำหนักและจำนวนเงินต้องเป็นจำนวนเต็ม",
      "eta": "จำนวนวันต้องเป็นจำนวนเต็ม และเร็วสุดต้องไม่มากกว่าช้าสุด"
    },
    "max_thickness": "ความหนาสูงสุดของพัสดุ",
    "max_thickness_hint": "แบบหย่อนตู้จดหมาย: 30 มม. (3 ซม.) เว้นว่าง = ไม่จำกัด"
  },
  "grid": {
    "open": "ใส่ค่าส่งตามน้ำหนักแบบเร็ว",
    "title": "ค่าส่งตามน้ำหนัก — {{zone}}",
    "description": "พิมพ์ค่าส่งของร้าน ช่องว่าง = ไม่มีขั้นราคาที่น้ำหนักนั้น",
    "way": "วิธีส่ง",
    "up_to": "ถึง {{weight}}",
    "cell": "{{name}} ถึง {{weight}}",
    "hint": "กล่องใช้ขั้นแรกที่ใส่ได้ ขั้นที่หนักกว่าห้ามถูกกว่า",
    "add_weight": "เพิ่มขั้นน้ำหนัก (กรัม)",
    "add_weight_button": "เพิ่มขั้น",
    "weight_invalid": "ใส่น้ำหนัก 1–30,000 กรัม",
    "whole_yen": "ค่าส่งต้องเป็นเยนจำนวนเต็ม",
    "download": "ดาวน์โหลดไปใช้ในสเปรดชีต",
    "upload": "อ่านไฟล์สเปรดชีต",
    "csv_unreadable": "ไฟล์นี้ไม่มีคอลัมน์ \"code\" หรือคอลัมน์น้ำหนัก ดาวน์โหลดตารางก่อนแล้วกรอกไฟล์นั้น",
    "csv_unknown": "ไม่อยู่ในตารางนี้ จึงไม่ได้ใส่: {{codes}}",
    "save": "บันทึกค่าส่ง",
    "saved_other": "บันทึกวิธีส่งแล้ว {{count}} แบบ",
    "some_failed_other": "มี {{count}} แถวที่ยังไม่ได้บันทึก — ดูข้อความสีแดง"
  },
  "carrier": {
    "intro": "ลิงก์ติดตามพัสดุในอีเมลลูกค้าจะเปิดหน้าที่ตั้งไว้ที่นี่ ต้องเป็นเว็บของบริษัทขนส่งเอง",
    "load_failed": "โหลดรายชื่อบริษัทขนส่งไม่ได้",
    "domestic": "ในญี่ปุ่น",
    "international": "ต่างประเทศ",
    "insurable": "ทำประกันได้",
    "customs": "ต้องมีใบศุลกากร",
    "changed_by_shop": "ร้านแก้แล้ว",
    "on": "ใช้อยู่",
    "off": "ไม่ใช้",
    "use": "ใช้บริษัทนี้",
    "warning_ignored": "ใช้การแก้ของร้านไม่ได้ (เว็บไม่ถูก) จึงใช้หน้ามาตรฐานแทน",
    "page": "หน้าติดตามพัสดุ",
    "page_hint": "https บนเว็บของบริษัท ใส่ {n} ตรงที่เลขพัสดุอยู่",
    "sample": "เลขที่ใช้ทดสอบ",
    "sample_hint": "ตัวอย่าง: {{example}}",
    "test": "เปิดหน้าติดตามของ {{name}}",
    "test_unavailable": "ใช้หน้านี้ไม่ได้: ต้องเป็น https บนเว็บของบริษัท และมี {n} 1 ครั้ง",
    "save_page": "บันทึกหน้าติดตาม",
    "back_to_default": "กลับไปใช้หน้ามาตรฐาน",
    "saved": "บันทึก {{name}} แล้ว",
    "template_refused": "ใช้หน้านี้ไม่ได้: ต้องเป็น https บนเว็บของบริษัทเอง และมี {n} 1 ครั้ง"
  },
  "duties": {
    "intro": "แต่ละตลาดใครจ่ายภาษีนำเข้า และอัตราที่หน้าชำระเงินใช้ประมาณ อัตราเปลี่ยนบ่อย — แก้ที่นี่แล้วใช้ทันที",
    "source": "ข้อมูลวิจัย: ภาษีนำเข้าสหรัฐสำหรับการ์ดจากญี่ปุ่น ≈ 12.5% ตั้งแต่ 2026-07-24 (ตรวจ 2026-09-24 ยังไม่ยืนยันตามตัวบทกฎหมาย) — {{file}} ตรวจกับ Zonos/ศุลกากรอีกครั้งก่อนส่ง",
    "no_access": "ภาษีนำเข้าอยู่กับการตั้งค่าภาษี",
    "no_access_body": "ให้เจ้าของร้านหรือผู้จัดการเปิดหน้านี้",
    "load_failed": "โหลดตลาดไม่ได้",
    "every_other_country": "ประเทศอื่นทั้งหมด",
    "updated": "แก้ล่าสุด",
    "us_rule": "สหรัฐ ทางไปรษณีย์ $100–2,500: ต้องจ่ายภาษีล่วงหน้า (DDP ผ่าน Zonos) ระบบทำให้เอง",
    "who_pays": "ใครจ่ายภาษีนำเข้า",
    "mode": {
      "DDU": "ลูกค้าจ่ายตอนรับของ (DDU)",
      "DDP": "ร้านจ่ายล่วงหน้า (DDP)"
    },
    "mode_hint": {
      "DDU": "บริษัทขนส่งอาจเก็บภาษีและค่าธรรมเนียมจากลูกค้า",
      "DDP": "หน้าชำระเงินแสดงยอดประมาณ ร้านจ่ายก่อนส่ง"
    },
    "percent": "อัตราภาษีนำเข้า",
    "percent_hint": "ว่าง = ไม่มียอดประมาณ ทศนิยมไม่เกิน 3 ตำแหน่ง เช่น 12.5",
    "percent_invalid": "ใส่อัตรา 0–100 เช่น 12.5",
    "notice": "ข้อความที่ลูกค้าอ่านตอนชำระเงิน",
    "notice_hint": "ว่าง = ข้อความมาตรฐานของร้านสำหรับตัวเลือกนี้",
    "save": "บันทึกภาษีนำเข้า",
    "saved": "บันทึกภาษีนำเข้าของ {{name}} แล้ว",
    "confirm_title": "เปลี่ยนภาษีนำเข้าของ {{name}}?",
    "confirm_body": "หน้าชำระเงินใหม่จะแสดงทันที",
    "confirm_percent": "อัตรา: {{percent}}%",
    "confirm_no_percent": "ไม่มีอัตรา (ไม่มียอดประมาณ)"
  },
  "packaging": {
    "intro": "ตัวเลขที่ระบบบวกให้ทุกพัสดุเพื่อคิดน้ำหนักและความหนา (ตัวเลขเดียวกับตอนลูกค้าสั่งซื้อ) แก้แล้วลูกค้าคนถัดไปเห็นทันที",
    "load_failed": "โหลดน้ำหนักการแพ็กไม่ได้",
    "box": "วัสดุแพ็กต่อกล่อง",
    "box_hint": "กล่อง บับเบิล และวัสดุกันกระแทก",
    "pack": {
      "raw_single": "การ์ด 1 ใบ (สลีฟ + ท็อปโหลดเดอร์ + ทีมแบ็ก) — เมื่อการ์ดไม่มีน้ำหนักของตัวเอง",
      "graded_single": "การ์ดเกรด 1 ใบ (สลีฟสแลบ + กล่องแข็ง + บับเบิล)",
      "sealed_product": "กล่อง/ซองซีล 1 ชิ้น — เมื่อไม่มีน้ำหนักของตัวเอง",
      "supplies": "อุปกรณ์ 1 ชิ้น — เมื่อไม่มีน้ำหนักของตัวเอง"
    },
    "insured_from": "เห็นเฉพาะวิธีมีประกันตั้งแต่",
    "insured_from_hint": "ออเดอร์ตั้งแต่มูลค่านี้จะเห็นเฉพาะวิธีที่มีประกัน (แนะนำเซ็นรับและถ่ายรูปกล่อง)",
    "read_only": "เฉพาะคนที่แก้การตั้งค่าร้านได้เท่านั้นที่เปลี่ยนตัวเลขเหล่านี้ได้",
    "weight": "น้ำหนักวัสดุแพ็ก",
    "thickness": "ความหนาวัสดุแพ็ก",
    "weight_one": "น้ำหนักต่อชิ้น",
    "thickness_one": "ความหนาต่อชิ้น (หลังแพ็ก)",
    "start_value": "ค่าเริ่มต้น: {{value}}",
    "thickness_note": "ความหนาเป็นตัวตัดสินว่าใช้วิธีส่งที่จำกัด 3 ซม. ได้ไหม (クリックポスト, ゆうパケット, レターパックライト) ค่าเริ่มต้นเป็นค่าประมาณ — ลองวัดพัสดุที่แพ็กจริงแล้วใส่ตัวเลขของร้านเอง",
    "save": "บันทึก",
    "saved": "บันทึกแล้ว — ลูกค้าคนถัดไปเห็นค่าส่งใหม่",
    "reset": "กลับเป็นค่าเริ่มต้น",
    "conflict": "มีคนอื่นบันทึกตัวเลขนี้ไปเมื่อสักครู่ ช่องที่คุณไม่ได้แก้เปลี่ยนเป็นตัวเลขของเขาแล้ว ส่วนตัวเลขที่คุณพิมพ์ยังอยู่แต่ยังไม่ได้บันทึก (ใต้แต่ละช่องมีตัวเลขที่บันทึกอยู่ตอนนี้) — กดบันทึกถ้าจะใช้ของคุณ หรือกดใช้ตัวเลขที่บันทึกไว้",
    "problem": {
      "number": "ใส่ตัวเลขจำนวนเต็มในช่วงที่กำหนด",
      "summary_other": "มี {{count}} ช่องที่ต้องใส่ตัวเลขจำนวนเต็มในช่วงที่กำหนด — ดูข้อความสีแดง"
    },
    "saved_now": "ที่บันทึกอยู่ตอนนี้: {{value}}",
    "take_saved": "ใช้ตัวเลขที่บันทึกไว้"
  },
  "product_type": {
    "raw_single": "การ์ด (ไม่เกรด)",
    "graded_single": "การ์ดเกรด",
    "sealed_product": "กล่อง/ซองซีล",
    "supplies": "อุปกรณ์"
  },
  "calc": {
    "form": "สิ่งที่จะลอง",
    "intro": "เลือกปลายทางและของ — รายการจะแสดงตรงกับที่ลูกค้าเห็น ไม่มีการสั่งหรือจองของ",
    "how": "การรับของ",
    "method": {
      "ship": "ส่ง",
      "pickup": "รับที่ร้าน"
    },
    "country": "ประเทศ",
    "prefecture": "จังหวัด",
    "prefecture_any": "ไม่ระบุ",
    "lookup": "การ์ดหรือกล่องในร้าน (สแกนหรือพิมพ์รหัส)",
    "lookup_button": "เพิ่ม",
    "lookup_hint": "ราคาและน้ำหนักจะใส่ให้เอง",
    "not_found": "ไม่มีสินค้าที่มีรหัสนี้ในร้าน",
    "item": "ชิ้นที่ {{row}}",
    "kind": "ประเภท",
    "qty": "จำนวน",
    "pieces": "ชิ้น",
    "price": "ชิ้นที่ {{row}}: ราคา",
    "weight": "น้ำหนักต่อชิ้น",
    "weight_hint": "ว่าง = น้ำหนักมาตรฐาน (แท็บการแพ็ก)",
    "export_price": "ราคาไม่รวมภาษี (ส่งออก)",
    "export_price_hint": "ใช้ประมาณภาษีนำเข้า",
    "add_item": "เพิ่มของ",
    "remove_item": "เอาชิ้นที่ {{row}} ออก",
    "result": "สิ่งที่ลูกค้าเห็น",
    "fill_in": "ใส่ราคาเพื่อดูวิธีส่ง",
    "zone": "โซน",
    "pickup": "รับที่ร้าน",
    "parcel_weight": "น้ำหนักกล่อง",
    "value": "มูลค่า",
    "notices": "ข้อความตอนชำระเงิน",
    "options": "วิธีส่ง ถูกที่สุดก่อน",
    "free": "ส่งฟรี",
    "insured_up_to": "ประกันถึง {{amount}}",
    "duty_estimate": "ภาษีนำเข้าประมาณ {{amount}}",
    "hidden": "วิธีที่ไม่แสดงสำหรับกล่องนี้",
    "hidden_row": "{{name}} — {{reason}}",
    "hidden_reason": {
      "insurance_required": "ไม่มีประกัน (ออเดอร์มูลค่าสูง)",
      "declared_value_too_high": "มูลค่าของเกินที่ส่งได้",
      "too_heavy": "หนักเกิน",
      "subtotal_out_of_range": "ยอดซื้อไม่อยู่ในช่วง",
      "too_thick": "หนาเกิน",
      "carrier_off": "ปิดบริษัทนี้ในโซนนี้"
    },
    "thickness": "ความหนาต่อชิ้น",
    "thickness_hint": "เว้นว่าง = ความหนามาตรฐาน (แท็บการแพ็ก)",
    "parcel_thickness": "ความหนาพัสดุ"
  },
  "notice": {
    "checkout_ddp_us_notice": "สหรัฐ: ร้านจ่ายภาษีนำเข้าล่วงหน้า (รวมในราคาที่แสดง)",
    "checkout_ddu_notice": "อาจมีภาษีนำเข้าและค่าธรรมเนียมตอนรับของ",
    "checkout_duties_estimate_unavailable": "ไม่มียอดประมาณภาษี: มีของที่ไม่มีราคาไม่รวมภาษี",
    "checkout_duties_us_ddp": "สหรัฐ: ร้านจ่ายภาษีนำเข้าล่วงหน้า",
    "checkout_duties_ddu": "อาจมีภาษีนำเข้าและค่าธรรมเนียมตอนรับของ",
    "checkout_duties_uk_135": "สหราชอาณาจักร: ออเดอร์ไม่เกิน £135 บวก VAT",
    "shipping_insurance_required": "ออเดอร์ตั้งแต่ {{threshold}} ส่งเฉพาะแบบมีประกัน",
    "shipping_free_shipping_applied": "ได้ส่งฟรี",
    "other": "ลูกค้าจะเห็นข้อความเรื่องภาษีนำเข้าหรือการส่ง"
  },
  "problem": {
    "zone_conflict": "อยู่ในโซน {{zone}} แล้ว: {{places}} ให้เอาออกจากโซนนั้นก่อน หรือปิดโซนนั้น",
    "zone_has_rates": "โซนนี้ยังมีวิธีส่ง ลบวิธีส่งก่อน หรือปิดโซน",
    "unknown_prefecture": "ไม่รู้จักจังหวัด: {{value}}",
    "rate": {
      "thresholds_not_ascending": "แถว {{row}}: \"ถึง\" ต้องมากกว่าแถวข้างบน (ขั้นราคาทับกัน)",
      "price_decreases_with_weight": "แถว {{row}}: ขั้นที่หนักกว่าห้ามถูกกว่าแถวข้างบน",
      "threshold_required": "แถว {{row}}: ใส่น้ำหนักหรือยอดใน \"ถึง\"",
      "required_for_type": "เพิ่มอย่างน้อย 1 แถวที่มีค่าส่ง",
      "unknown_carrier": "ไม่รู้จักบริษัทขนส่งนี้ เลือกบริษัทอื่น",
      "greater_than_max": "ตัวเลขน้อยสุดมากกว่าตัวเลขมากสุด",
      "before_effective_from": "วันสิ้นสุดอยู่ก่อนวันเริ่ม"
    },
    "quote": {
      "no_zone": "ไม่มีโซนไหนรวมพื้นที่นี้ ลูกค้าที่นั่นจึงสั่งไม่ได้",
      "no_rates": "โซนนี้ยังไม่มีวิธีส่ง",
      "all_rates_hidden": "ไม่มีวิธีส่งที่เหมาะกับกล่องนี้ (มูลค่าสูง หนักเกิน หรือยอดซื้อไม่อยู่ในช่วง)",
      "no_pickup_location": "ยังไม่ได้ตั้งร้านสำหรับรับของ",
      "too_heavy": "กล่อง ({{weight}} g) หนักกว่าทุกวิธีส่ง (สูงสุด {{max}} g)"
    }
  }
}
